import { render, staticRenderFns } from "./OpenRequestModal.vue?vue&type=template&id=dbbc8732&scoped=true"
import script from "./OpenRequestModal.vue?vue&type=script&lang=ts"
export * from "./OpenRequestModal.vue?vue&type=script&lang=ts"
import style0 from "./OpenRequestModal.vue?vue&type=style&index=0&id=dbbc8732&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbbc8732",
  null
  
)

export default component.exports